// Types
import { POSCreditTypeGroupProps } from 'components/pos-credit/POSCredit.types';

const getPosCreditOptionLabel = (creditTypeGroup: POSCreditTypeGroupProps): string => {
  const typeLabel = `${creditTypeGroup.creditTypesPayload[0].rate}% APR`;
  const termsList: (number | undefined)[] = [];
  let terms;

  if (creditTypeGroup.creditTypesPayload) {
    creditTypeGroup.creditTypesPayload.forEach((creditType) => {
      termsList.push(creditType.term);
    });
  }

  if (termsList.length === 1) {
    terms = `${termsList} months`;
  } else if (termsList.length > 1) {
    terms = `${termsList.slice(0, -1).join(', ')} or ${termsList.slice(-1)} months`;
  }

  return `${typeLabel} over ${terms}`;
};

export default getPosCreditOptionLabel;
